import React from "react";
import { FormattedMessage } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { loginWithPasswordWatcher } from "../../redux/actions/loginactioncreators";
import { NewFADVLoginForm } from "./NewFADVLoginForm";

export const SignUpComplete = () => {
  const dispatch = useDispatch();
  const clientId = useSelector(state => state.loginForm.clientId);
  const password = useSelector(state => state.loginForm.password);
  const accountNumber = useSelector(state => state.loginForm.accountNumber);
  const userAttributes = useSelector(state => state.loginForm.userInfo?.UserAttributes);
  const email = userAttributes?.email;
  const passwordExpiresAt = userAttributes?.["custom:passwordExpiresAt"] ?? "0";
  const newPasswordRequired = passwordExpiresAt === "-1";

  const handleContinue = () => {
    dispatch(loginWithPasswordWatcher({
      username: email,
      password,
      accountNumber,
      clientId
    }));
  };

  return (
    <NewFADVLoginForm
      onSubmit={handleContinue}
      headerContent={<FormattedMessage id="signup.completeHeader" defaultMessage="Sign Up Complete" description="Header text shown after successful sign-up migration setup" />}
      submitButtonText={<FormattedMessage id="signup.continue" defaultMessage="Continue" description="Button text to continue after signup completion" />}
      onEscapeKey={handleContinue}
    >
      <p className="text-primary-fg text-base leading-6">
        <FormattedMessage
          id="signup.completeBlurb"
          defaultMessage="Your account has been updated. Going forward, please sign in using your email address instead of your previous username."
          description="Instructional message shown after signup completion before continuing to sign in"
        />
      </p>
      <div id="loginDetails" className="bg-blue-50 border border-blue-200 rounded p-4 space-y-2" role="status" aria-live="polite">
        {email && <p className="text-primary-fg text-base leading-6">
          <FormattedMessage
            id="signup.completeEmail"
            defaultMessage="Email: {email}"
            description="Email value shown after signup completion so user knows future sign-in username"
            values={{ email: email.toLowerCase() }}
          />
        </p>}
        {accountNumber && <p className="text-primary-fg text-base leading-6">
          <FormattedMessage
            id="signup.completeClientId"
            defaultMessage="Client ID: {accountNumber}"
            description="Client ID/account number shown after signup completion so user knows future sign-in credentials"
            values={{ accountNumber: accountNumber.toUpperCase() }}
          />
        </p>}
        <p className="text-primary-fg text-base leading-6">
          {newPasswordRequired ? (
            <FormattedMessage
              id="signup.completePasswordUpdateRequired"
              defaultMessage="Your password will need to be updated. Please have your current password ready before continuing."
              description="Message shown on signup complete when user must update password on next step"
            />
          ) : (
            <FormattedMessage
              id="signup.completeCurrentPassword"
              defaultMessage="You'll log in with your current password."
              description="Message shown on signup complete when user can continue with current password"
            />
          )}
        </p>
      </div>
    </NewFADVLoginForm>
  );
};